<template>
  <div style='display:flex'>
    <div v-for="(icon, index) in icons" :key="index">
      <!--<svg class="table__icon table__icon--medium" @click="icon.fn()">
        <use v-show="icon.svg == 'icon-user-plus'" href="@/assets/sprite.svg#icon-user-plus"></use>
        <use v-show="icon.svg == 'icon-checkmark'" href="@/assets/sprite.svg#icon-checkmark"></use>
        <use v-show="icon.svg == 'icon-plus1'" href="@/assets/sprite.svg#icon-plus1"></use>-->
        <!--<use v-if="icon.svg == 'icon-user-plus'" :href="getIcon('icon-user-plus')"></use>
        <use v-if="icon.svg == 'icon-checkmark'" :href="getIcon('icon-checkmark')"></use>-->
      <!--</svg>-->

      <svg v-show="icon.svg == 'icon-user-plus' && $can('create', 'users')" class="table__icon table__icon--medium" @click="icon.fn()">
        <use href="@/assets/sprite.svg#icon-user-plus"></use>
      </svg>
      <svg v-show="icon.svg == 'icon-checkmark'" class="table__icon table__icon--medium" @click="icon.fn()">
        <use href="@/assets/sprite.svg#icon-checkmark"></use>
      </svg>
       <svg v-show="icon.svg == 'icon-plus1'  && $can('create', 'groupabilities')" class="table__icon table__icon--medium" @click="icon.fn()">
        <use href="@/assets/sprite.svg#icon-plus1"></use>
      </svg>
      <svg v-show="icon.svg == 'icon-camera'" class="table__icon table__icon--medium" @click="icon.fn()">
        <use href="@/assets/sprite.svg#icon-camera"></use>
      </svg>
      <svg v-show="icon.svg == 'icon-arrow-left'" class="table__icon table__icon--medium" @click="icon.fn()">
        <use href="@/assets/sprite.svg#icon-arrow-left"></use>
      </svg>
       <svg v-show="icon.svg == 'icon-arrow-right'" class="table__icon table__icon--medium" @click="icon.fn()">
        <use href="@/assets/sprite.svg#icon-arrow-right"></use>
      </svg>
      <svg v-show="icon.svg == 'icon-upload3'" class="table__icon table__icon--medium" @click="icon.fn()">
        <use href="@/assets/sprite.svg#icon-upload3"></use>
      </svg>
       <svg v-show="icon.svg == 'icon-trash'" class="table__icon table__icon--medium" @click="icon.fn()">
        <use href="@/assets/sprite.svg#icon-trash"></use>
      </svg>
    </div>

    <transition name="popup">
      <component :is="componentName" @close="componentName =''"></component>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
// import iconSVG from '../assets/sprite.svg'
const { mapGetters } = createNamespacedHelpers('subheader')

export default {
  data: function () {
    return {
      componentName: ''
    }
  },
  computed: {
    ...mapGetters({
      icons: 'getIcons'
    })
  },
  methods: {
    /* getIcon (name) {
      return `${iconSVG}#${name}`
    } */
  }
}
</script>
